import { useTranslation } from 'react-i18next';

export const EmptySearchResultsList = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-2 flex items-center justify-center rounded-md bg-gray-50 p-6 text-center text-sm font-normal leading-5 text-gray-500">
      {t('orderForms:form.emptySearch')}
    </div>
  );
};
